﻿/**
 * color.repository
 * @namespace portal
 */

(function () {
	'use strict';

	/** add the repo */
	angular.module('nha.portal').service('color.repository', colorRepo);

	/** injection */
	colorRepo.$inject = ['$q'];

	/** implementation */
	function colorRepo($q) {
		/** private properties */
		var colors = [
			{ 'label': 'Gray', 'value': '#8E9697'},
			{ 'label': 'Blue', 'value': '#00D3F7'},
			{ 'label': 'Medium Blue', 'value': '#00AEEF' },
			{ 'label': 'Dark Blue', 'value': '#00539F' },
			{ 'label': 'Green', 'value': '#AED900'},
			{ 'label': 'Dark Green', 'value': '#77B800'},
			{ 'label': 'Orange', 'value': '#FE6401'}
		];

		/** get the colors */
		function getAll() {
			/** create a promise */
			var deferred = $q.defer();

			/** resolve the promise */
			deferred.resolve(colors);

			/** return the promise */
			return deferred.promise;
		}

		/** create the service */
		var service = {
			getAll: getAll
		};

		/** return the service */
		return service;
	}
})();